import {
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_SUCCESS,
  SET_LOADING,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  SUBMIT_DATA,
  SUBMIT_DATA_SUCCESS,
  DELETE,
  DELETE_SUCCESS,
  REQUEST_ERROR,
  GET_REFERENCE_DATA_SUCCESS,
} from '../types/transaction';
import { updateStates } from '../../utils/reducer';

const initState = {
  list: {
    data: [],
    metadata: {},
  },
  isLoading: false,
  error: '',
  item: {},
  orderStatus: [],
};

const reducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case GET_TRANSACTIONS:
    case GET_DETAIL:
    case SUBMIT_DATA:
    case DELETE:
      return updateStates(state, {
        isLoading: true,
      });

    case GET_TRANSACTIONS_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        list: action.data,
      });

    case GET_DETAIL_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: action.data,
      });

    case GET_REFERENCE_DATA_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        ...action.data,
      });
    case SET_LOADING:
      return updateStates(state, {
        isLoading: action.isLoading,
      });

    case REQUEST_ERROR:
      return updateStates(state, {
        isLoading: false,
      });

    case SUBMIT_DATA_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: action.data,
      });

    case DELETE_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: null,
      });
    default:
      return state;
  }
};

export default reducer;
